/* tslint:disable */
/* eslint-disable */
/**
 * Universal Process API
 * Universal Process App API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BusinessCustomerDto } from '../models';
// @ts-ignore
import type { ContactSearchResponseDto } from '../models';
// @ts-ignore
import type { CreateBusinessCustomerRequestDto } from '../models';
// @ts-ignore
import type { CreateForeignBusinessCustomerRequestDto } from '../models';
// @ts-ignore
import type { CreateIndividualCustomerRequestDto } from '../models';
// @ts-ignore
import type { CustomerCreationResponseDto } from '../models';
// @ts-ignore
import type { CustomerErrorResponseDto } from '../models';
// @ts-ignore
import type { CustomerSearchResponseDto } from '../models';
// @ts-ignore
import type { CustomerTypeResponseDto } from '../models';
// @ts-ignore
import type { ForeignBusinessCustomerDto } from '../models';
// @ts-ignore
import type { GetBusinessCustomerResponseDto } from '../models';
// @ts-ignore
import type { GetForeignBusinessCustomerResponseDto } from '../models';
// @ts-ignore
import type { GetIndividualCustomerResponseDto } from '../models';
// @ts-ignore
import type { IndividualCustomerDto } from '../models';
// @ts-ignore
import type { RejectCustomerRequestDto } from '../models';
// @ts-ignore
import type { SearchCustomerContactsRequestDto } from '../models';
// @ts-ignore
import type { SearchCustomersRequestDto } from '../models';
/**
 * RestCustomersApi - axios parameter creator
 */
export const RestCustomersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add contact to customer
         * @param {number} customerId 
         * @param {number} contactId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCustomerContact: async (customerId: number, contactId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('addCustomerContact', 'customerId', customerId)
            // verify required parameter 'contactId' is not null or undefined
            assertParamExists('addCustomerContact', 'contactId', contactId)
            const localVarPath = `/api/customers/{customerId}/contacts/{contactId}`
                .replace('{customerId}', encodeURIComponent(String(customerId)))
                .replace('{contactId}', encodeURIComponent(String(contactId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * PROSPECT or REJECTED to ACTIVE; records the signed-in user and the time as the approver and clears an earlier rejection. Requires CUSTOMER_APPROVE. Leaves an entry on the customer timeline.
         * @summary Approve a Prospect or a rejected customer (Zatwierdzenie klienta)
         * @param {number} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveCustomer: async (customerId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('approveCustomer', 'customerId', customerId)
            const localVarPath = `/api/customers/{customerId}/approve`
                .replace('{customerId}', encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The customer is created as a Prospect (PROSPECT) unless `status` is ACTIVE, which needs CUSTOMER_APPROVE and records the signed-in user as the approver.
         * @param {CreateBusinessCustomerRequestDto} createBusinessCustomerRequestDto Create customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBusinessCustomer: async (createBusinessCustomerRequestDto: CreateBusinessCustomerRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createBusinessCustomerRequestDto' is not null or undefined
            assertParamExists('createBusinessCustomer', 'createBusinessCustomerRequestDto', createBusinessCustomerRequestDto)
            const localVarPath = `/api/business-customers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createBusinessCustomerRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The customer is created as a Prospect (PROSPECT) unless `status` is ACTIVE, which needs CUSTOMER_APPROVE and records the signed-in user as the approver.
         * @param {CreateForeignBusinessCustomerRequestDto} createForeignBusinessCustomerRequestDto Create foreign customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createForeignBusinessCustomer: async (createForeignBusinessCustomerRequestDto: CreateForeignBusinessCustomerRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createForeignBusinessCustomerRequestDto' is not null or undefined
            assertParamExists('createForeignBusinessCustomer', 'createForeignBusinessCustomerRequestDto', createForeignBusinessCustomerRequestDto)
            const localVarPath = `/api/foreign-business-customers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createForeignBusinessCustomerRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The customer is created as a Prospect (PROSPECT) unless `status` is ACTIVE, which needs CUSTOMER_APPROVE and records the signed-in user as the approver.
         * @param {CreateIndividualCustomerRequestDto} createIndividualCustomerRequestDto Create customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIndividualCustomer: async (createIndividualCustomerRequestDto: CreateIndividualCustomerRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createIndividualCustomerRequestDto' is not null or undefined
            assertParamExists('createIndividualCustomer', 'createIndividualCustomerRequestDto', createIndividualCustomerRequestDto)
            const localVarPath = `/api/individual-customers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createIndividualCustomerRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete contact from customer
         * @param {number} customerId 
         * @param {number} contactId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomerContact: async (customerId: number, contactId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('deleteCustomerContact', 'customerId', customerId)
            // verify required parameter 'contactId' is not null or undefined
            assertParamExists('deleteCustomerContact', 'contactId', contactId)
            const localVarPath = `/api/customers/{customerId}/contacts/{contactId}`
                .replace('{customerId}', encodeURIComponent(String(customerId)))
                .replace('{contactId}', encodeURIComponent(String(contactId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBusinessCustomer: async (customerId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getBusinessCustomer', 'customerId', customerId)
            const localVarPath = `/api/business-customers/{customerId}`
                .replace('{customerId}', encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerType: async (customerId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getCustomerType', 'customerId', customerId)
            const localVarPath = `/api/business-customers/{customerId}/type`
                .replace('{customerId}', encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForeignBusinessCustomer: async (customerId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getForeignBusinessCustomer', 'customerId', customerId)
            const localVarPath = `/api/foreign-business-customers/{customerId}`
                .replace('{customerId}', encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIndividualCustomer: async (customerId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getIndividualCustomer', 'customerId', customerId)
            const localVarPath = `/api/individual-customers/{customerId}`
                .replace('{customerId}', encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * PROSPECT to REJECTED with a mandatory reason; records the signed-in user and the time as the rejecter. Requires CUSTOMER_APPROVE. Leaves an entry with the reason on the customer timeline.
         * @summary Reject a Prospect with a reason
         * @param {number} customerId 
         * @param {RejectCustomerRequestDto} rejectCustomerRequestDto Reject a Prospect
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectCustomer: async (customerId: number, rejectCustomerRequestDto: RejectCustomerRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('rejectCustomer', 'customerId', customerId)
            // verify required parameter 'rejectCustomerRequestDto' is not null or undefined
            assertParamExists('rejectCustomer', 'rejectCustomerRequestDto', rejectCustomerRequestDto)
            const localVarPath = `/api/customers/{customerId}/reject`
                .replace('{customerId}', encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rejectCustomerRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * REJECTED to PROSPECT, clearing the rejection reason, rejecter and time. Requires CONTACT_EDIT (or CONTACT_MANAGE_ALL). Leaves an entry on the customer timeline.
         * @summary Submit a rejected customer again as a Prospect
         * @param {number} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resubmitCustomer: async (customerId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('resubmitCustomer', 'customerId', customerId)
            const localVarPath = `/api/customers/{customerId}/resubmit`
                .replace('{customerId}', encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get list of customers contacts
         * @param {number} page 
         * @param {number} pageSize 
         * @param {number} customerId 
         * @param {SearchCustomerContactsRequestDto} searchCustomerContactsRequestDto Customer contacts search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCustomerContacts: async (page: number, pageSize: number, customerId: number, searchCustomerContactsRequestDto: SearchCustomerContactsRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('searchCustomerContacts', 'page', page)
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('searchCustomerContacts', 'pageSize', pageSize)
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('searchCustomerContacts', 'customerId', customerId)
            // verify required parameter 'searchCustomerContactsRequestDto' is not null or undefined
            assertParamExists('searchCustomerContacts', 'searchCustomerContactsRequestDto', searchCustomerContactsRequestDto)
            const localVarPath = `/api/customers/{customerId}/contacts-search`
                .replace('{customerId}', encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchCustomerContactsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get list of customers
         * @param {number} page 
         * @param {number} pageSize 
         * @param {SearchCustomersRequestDto} searchCustomersRequestDto Customer search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCustomers: async (page: number, pageSize: number, searchCustomersRequestDto: SearchCustomersRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('searchCustomers', 'page', page)
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('searchCustomers', 'pageSize', pageSize)
            // verify required parameter 'searchCustomersRequestDto' is not null or undefined
            assertParamExists('searchCustomers', 'searchCustomersRequestDto', searchCustomersRequestDto)
            const localVarPath = `/api/customers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchCustomersRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The edit does not change the approval state and never leaves or enters PROSPECT or REJECTED (400 CUSTOMER_STATUS_CHANGE_NOT_ALLOWED); ACTIVE and INACTIVE switch freely. A customer that does not exist is answered with 404 CUSTOMER_NOT_FOUND.
         * @param {number} customerId 
         * @param {BusinessCustomerDto} businessCustomerDto Update business customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBusinessCustomer: async (customerId: number, businessCustomerDto: BusinessCustomerDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('updateBusinessCustomer', 'customerId', customerId)
            // verify required parameter 'businessCustomerDto' is not null or undefined
            assertParamExists('updateBusinessCustomer', 'businessCustomerDto', businessCustomerDto)
            const localVarPath = `/api/business-customers/{customerId}`
                .replace('{customerId}', encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(businessCustomerDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The edit does not change the approval state and never leaves or enters PROSPECT or REJECTED (400 CUSTOMER_STATUS_CHANGE_NOT_ALLOWED); ACTIVE and INACTIVE switch freely. A customer that does not exist is answered with 404 CUSTOMER_NOT_FOUND.
         * @param {number} customerId 
         * @param {ForeignBusinessCustomerDto} foreignBusinessCustomerDto Update foreign business customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateForeignBusinessCustomer: async (customerId: number, foreignBusinessCustomerDto: ForeignBusinessCustomerDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('updateForeignBusinessCustomer', 'customerId', customerId)
            // verify required parameter 'foreignBusinessCustomerDto' is not null or undefined
            assertParamExists('updateForeignBusinessCustomer', 'foreignBusinessCustomerDto', foreignBusinessCustomerDto)
            const localVarPath = `/api/foreign-business-customers/{customerId}`
                .replace('{customerId}', encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(foreignBusinessCustomerDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The edit does not change the approval state and never leaves or enters PROSPECT or REJECTED (400 CUSTOMER_STATUS_CHANGE_NOT_ALLOWED); ACTIVE and INACTIVE switch freely. A customer that does not exist is answered with 404 CUSTOMER_NOT_FOUND.
         * @param {number} customerId 
         * @param {IndividualCustomerDto} individualCustomerDto Update customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIndividualCustomer: async (customerId: number, individualCustomerDto: IndividualCustomerDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('updateIndividualCustomer', 'customerId', customerId)
            // verify required parameter 'individualCustomerDto' is not null or undefined
            assertParamExists('updateIndividualCustomer', 'individualCustomerDto', individualCustomerDto)
            const localVarPath = `/api/individual-customers/{customerId}`
                .replace('{customerId}', encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(individualCustomerDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestCustomersApi - functional programming interface
 */
export const RestCustomersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestCustomersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add contact to customer
         * @param {number} customerId 
         * @param {number} contactId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addCustomerContact(customerId: number, contactId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addCustomerContact(customerId, contactId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestCustomersApi.addCustomerContact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * PROSPECT or REJECTED to ACTIVE; records the signed-in user and the time as the approver and clears an earlier rejection. Requires CUSTOMER_APPROVE. Leaves an entry on the customer timeline.
         * @summary Approve a Prospect or a rejected customer (Zatwierdzenie klienta)
         * @param {number} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approveCustomer(customerId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.approveCustomer(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestCustomersApi.approveCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The customer is created as a Prospect (PROSPECT) unless `status` is ACTIVE, which needs CUSTOMER_APPROVE and records the signed-in user as the approver.
         * @param {CreateBusinessCustomerRequestDto} createBusinessCustomerRequestDto Create customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBusinessCustomer(createBusinessCustomerRequestDto: CreateBusinessCustomerRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerCreationResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBusinessCustomer(createBusinessCustomerRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestCustomersApi.createBusinessCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The customer is created as a Prospect (PROSPECT) unless `status` is ACTIVE, which needs CUSTOMER_APPROVE and records the signed-in user as the approver.
         * @param {CreateForeignBusinessCustomerRequestDto} createForeignBusinessCustomerRequestDto Create foreign customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createForeignBusinessCustomer(createForeignBusinessCustomerRequestDto: CreateForeignBusinessCustomerRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerCreationResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createForeignBusinessCustomer(createForeignBusinessCustomerRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestCustomersApi.createForeignBusinessCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The customer is created as a Prospect (PROSPECT) unless `status` is ACTIVE, which needs CUSTOMER_APPROVE and records the signed-in user as the approver.
         * @param {CreateIndividualCustomerRequestDto} createIndividualCustomerRequestDto Create customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createIndividualCustomer(createIndividualCustomerRequestDto: CreateIndividualCustomerRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerCreationResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createIndividualCustomer(createIndividualCustomerRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestCustomersApi.createIndividualCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete contact from customer
         * @param {number} customerId 
         * @param {number} contactId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCustomerContact(customerId: number, contactId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCustomerContact(customerId, contactId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestCustomersApi.deleteCustomerContact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBusinessCustomer(customerId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBusinessCustomerResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBusinessCustomer(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestCustomersApi.getBusinessCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerType(customerId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerTypeResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerType(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestCustomersApi.getCustomerType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getForeignBusinessCustomer(customerId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetForeignBusinessCustomerResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getForeignBusinessCustomer(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestCustomersApi.getForeignBusinessCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIndividualCustomer(customerId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetIndividualCustomerResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIndividualCustomer(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestCustomersApi.getIndividualCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * PROSPECT to REJECTED with a mandatory reason; records the signed-in user and the time as the rejecter. Requires CUSTOMER_APPROVE. Leaves an entry with the reason on the customer timeline.
         * @summary Reject a Prospect with a reason
         * @param {number} customerId 
         * @param {RejectCustomerRequestDto} rejectCustomerRequestDto Reject a Prospect
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rejectCustomer(customerId: number, rejectCustomerRequestDto: RejectCustomerRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rejectCustomer(customerId, rejectCustomerRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestCustomersApi.rejectCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * REJECTED to PROSPECT, clearing the rejection reason, rejecter and time. Requires CONTACT_EDIT (or CONTACT_MANAGE_ALL). Leaves an entry on the customer timeline.
         * @summary Submit a rejected customer again as a Prospect
         * @param {number} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resubmitCustomer(customerId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resubmitCustomer(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestCustomersApi.resubmitCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get list of customers contacts
         * @param {number} page 
         * @param {number} pageSize 
         * @param {number} customerId 
         * @param {SearchCustomerContactsRequestDto} searchCustomerContactsRequestDto Customer contacts search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchCustomerContacts(page: number, pageSize: number, customerId: number, searchCustomerContactsRequestDto: SearchCustomerContactsRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContactSearchResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchCustomerContacts(page, pageSize, customerId, searchCustomerContactsRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestCustomersApi.searchCustomerContacts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get list of customers
         * @param {number} page 
         * @param {number} pageSize 
         * @param {SearchCustomersRequestDto} searchCustomersRequestDto Customer search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchCustomers(page: number, pageSize: number, searchCustomersRequestDto: SearchCustomersRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerSearchResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchCustomers(page, pageSize, searchCustomersRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestCustomersApi.searchCustomers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The edit does not change the approval state and never leaves or enters PROSPECT or REJECTED (400 CUSTOMER_STATUS_CHANGE_NOT_ALLOWED); ACTIVE and INACTIVE switch freely. A customer that does not exist is answered with 404 CUSTOMER_NOT_FOUND.
         * @param {number} customerId 
         * @param {BusinessCustomerDto} businessCustomerDto Update business customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBusinessCustomer(customerId: number, businessCustomerDto: BusinessCustomerDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateBusinessCustomer(customerId, businessCustomerDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestCustomersApi.updateBusinessCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The edit does not change the approval state and never leaves or enters PROSPECT or REJECTED (400 CUSTOMER_STATUS_CHANGE_NOT_ALLOWED); ACTIVE and INACTIVE switch freely. A customer that does not exist is answered with 404 CUSTOMER_NOT_FOUND.
         * @param {number} customerId 
         * @param {ForeignBusinessCustomerDto} foreignBusinessCustomerDto Update foreign business customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateForeignBusinessCustomer(customerId: number, foreignBusinessCustomerDto: ForeignBusinessCustomerDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateForeignBusinessCustomer(customerId, foreignBusinessCustomerDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestCustomersApi.updateForeignBusinessCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The edit does not change the approval state and never leaves or enters PROSPECT or REJECTED (400 CUSTOMER_STATUS_CHANGE_NOT_ALLOWED); ACTIVE and INACTIVE switch freely. A customer that does not exist is answered with 404 CUSTOMER_NOT_FOUND.
         * @param {number} customerId 
         * @param {IndividualCustomerDto} individualCustomerDto Update customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateIndividualCustomer(customerId: number, individualCustomerDto: IndividualCustomerDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateIndividualCustomer(customerId, individualCustomerDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestCustomersApi.updateIndividualCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestCustomersApi - factory interface
 */
export const RestCustomersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestCustomersApiFp(configuration)
    return {
        /**
         * 
         * @summary Add contact to customer
         * @param {number} customerId 
         * @param {number} contactId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCustomerContact(customerId: number, contactId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addCustomerContact(customerId, contactId, options).then((request) => request(axios, basePath));
        },
        /**
         * PROSPECT or REJECTED to ACTIVE; records the signed-in user and the time as the approver and clears an earlier rejection. Requires CUSTOMER_APPROVE. Leaves an entry on the customer timeline.
         * @summary Approve a Prospect or a rejected customer (Zatwierdzenie klienta)
         * @param {number} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveCustomer(customerId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.approveCustomer(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * The customer is created as a Prospect (PROSPECT) unless `status` is ACTIVE, which needs CUSTOMER_APPROVE and records the signed-in user as the approver.
         * @param {CreateBusinessCustomerRequestDto} createBusinessCustomerRequestDto Create customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBusinessCustomer(createBusinessCustomerRequestDto: CreateBusinessCustomerRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CustomerCreationResponseDto> {
            return localVarFp.createBusinessCustomer(createBusinessCustomerRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * The customer is created as a Prospect (PROSPECT) unless `status` is ACTIVE, which needs CUSTOMER_APPROVE and records the signed-in user as the approver.
         * @param {CreateForeignBusinessCustomerRequestDto} createForeignBusinessCustomerRequestDto Create foreign customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createForeignBusinessCustomer(createForeignBusinessCustomerRequestDto: CreateForeignBusinessCustomerRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CustomerCreationResponseDto> {
            return localVarFp.createForeignBusinessCustomer(createForeignBusinessCustomerRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * The customer is created as a Prospect (PROSPECT) unless `status` is ACTIVE, which needs CUSTOMER_APPROVE and records the signed-in user as the approver.
         * @param {CreateIndividualCustomerRequestDto} createIndividualCustomerRequestDto Create customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIndividualCustomer(createIndividualCustomerRequestDto: CreateIndividualCustomerRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CustomerCreationResponseDto> {
            return localVarFp.createIndividualCustomer(createIndividualCustomerRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete contact from customer
         * @param {number} customerId 
         * @param {number} contactId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomerContact(customerId: number, contactId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCustomerContact(customerId, contactId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBusinessCustomer(customerId: number, options?: RawAxiosRequestConfig): AxiosPromise<GetBusinessCustomerResponseDto> {
            return localVarFp.getBusinessCustomer(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerType(customerId: number, options?: RawAxiosRequestConfig): AxiosPromise<CustomerTypeResponseDto> {
            return localVarFp.getCustomerType(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForeignBusinessCustomer(customerId: number, options?: RawAxiosRequestConfig): AxiosPromise<GetForeignBusinessCustomerResponseDto> {
            return localVarFp.getForeignBusinessCustomer(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIndividualCustomer(customerId: number, options?: RawAxiosRequestConfig): AxiosPromise<GetIndividualCustomerResponseDto> {
            return localVarFp.getIndividualCustomer(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * PROSPECT to REJECTED with a mandatory reason; records the signed-in user and the time as the rejecter. Requires CUSTOMER_APPROVE. Leaves an entry with the reason on the customer timeline.
         * @summary Reject a Prospect with a reason
         * @param {number} customerId 
         * @param {RejectCustomerRequestDto} rejectCustomerRequestDto Reject a Prospect
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectCustomer(customerId: number, rejectCustomerRequestDto: RejectCustomerRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.rejectCustomer(customerId, rejectCustomerRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * REJECTED to PROSPECT, clearing the rejection reason, rejecter and time. Requires CONTACT_EDIT (or CONTACT_MANAGE_ALL). Leaves an entry on the customer timeline.
         * @summary Submit a rejected customer again as a Prospect
         * @param {number} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resubmitCustomer(customerId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.resubmitCustomer(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get list of customers contacts
         * @param {number} page 
         * @param {number} pageSize 
         * @param {number} customerId 
         * @param {SearchCustomerContactsRequestDto} searchCustomerContactsRequestDto Customer contacts search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCustomerContacts(page: number, pageSize: number, customerId: number, searchCustomerContactsRequestDto: SearchCustomerContactsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ContactSearchResponseDto> {
            return localVarFp.searchCustomerContacts(page, pageSize, customerId, searchCustomerContactsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get list of customers
         * @param {number} page 
         * @param {number} pageSize 
         * @param {SearchCustomersRequestDto} searchCustomersRequestDto Customer search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCustomers(page: number, pageSize: number, searchCustomersRequestDto: SearchCustomersRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CustomerSearchResponseDto> {
            return localVarFp.searchCustomers(page, pageSize, searchCustomersRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * The edit does not change the approval state and never leaves or enters PROSPECT or REJECTED (400 CUSTOMER_STATUS_CHANGE_NOT_ALLOWED); ACTIVE and INACTIVE switch freely. A customer that does not exist is answered with 404 CUSTOMER_NOT_FOUND.
         * @param {number} customerId 
         * @param {BusinessCustomerDto} businessCustomerDto Update business customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBusinessCustomer(customerId: number, businessCustomerDto: BusinessCustomerDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateBusinessCustomer(customerId, businessCustomerDto, options).then((request) => request(axios, basePath));
        },
        /**
         * The edit does not change the approval state and never leaves or enters PROSPECT or REJECTED (400 CUSTOMER_STATUS_CHANGE_NOT_ALLOWED); ACTIVE and INACTIVE switch freely. A customer that does not exist is answered with 404 CUSTOMER_NOT_FOUND.
         * @param {number} customerId 
         * @param {ForeignBusinessCustomerDto} foreignBusinessCustomerDto Update foreign business customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateForeignBusinessCustomer(customerId: number, foreignBusinessCustomerDto: ForeignBusinessCustomerDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateForeignBusinessCustomer(customerId, foreignBusinessCustomerDto, options).then((request) => request(axios, basePath));
        },
        /**
         * The edit does not change the approval state and never leaves or enters PROSPECT or REJECTED (400 CUSTOMER_STATUS_CHANGE_NOT_ALLOWED); ACTIVE and INACTIVE switch freely. A customer that does not exist is answered with 404 CUSTOMER_NOT_FOUND.
         * @param {number} customerId 
         * @param {IndividualCustomerDto} individualCustomerDto Update customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIndividualCustomer(customerId: number, individualCustomerDto: IndividualCustomerDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateIndividualCustomer(customerId, individualCustomerDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestCustomersApi - interface
 */
export interface RestCustomersApiInterface {
    /**
     * 
     * @summary Add contact to customer
     * @param {number} customerId 
     * @param {number} contactId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addCustomerContact(customerId: number, contactId: number, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * PROSPECT or REJECTED to ACTIVE; records the signed-in user and the time as the approver and clears an earlier rejection. Requires CUSTOMER_APPROVE. Leaves an entry on the customer timeline.
     * @summary Approve a Prospect or a rejected customer (Zatwierdzenie klienta)
     * @param {number} customerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    approveCustomer(customerId: number, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * The customer is created as a Prospect (PROSPECT) unless `status` is ACTIVE, which needs CUSTOMER_APPROVE and records the signed-in user as the approver.
     * @param {CreateBusinessCustomerRequestDto} createBusinessCustomerRequestDto Create customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createBusinessCustomer(createBusinessCustomerRequestDto: CreateBusinessCustomerRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CustomerCreationResponseDto>;

    /**
     * The customer is created as a Prospect (PROSPECT) unless `status` is ACTIVE, which needs CUSTOMER_APPROVE and records the signed-in user as the approver.
     * @param {CreateForeignBusinessCustomerRequestDto} createForeignBusinessCustomerRequestDto Create foreign customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createForeignBusinessCustomer(createForeignBusinessCustomerRequestDto: CreateForeignBusinessCustomerRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CustomerCreationResponseDto>;

    /**
     * The customer is created as a Prospect (PROSPECT) unless `status` is ACTIVE, which needs CUSTOMER_APPROVE and records the signed-in user as the approver.
     * @param {CreateIndividualCustomerRequestDto} createIndividualCustomerRequestDto Create customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createIndividualCustomer(createIndividualCustomerRequestDto: CreateIndividualCustomerRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CustomerCreationResponseDto>;

    /**
     * 
     * @summary Delete contact from customer
     * @param {number} customerId 
     * @param {number} contactId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteCustomerContact(customerId: number, contactId: number, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {number} customerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBusinessCustomer(customerId: number, options?: RawAxiosRequestConfig): AxiosPromise<GetBusinessCustomerResponseDto>;

    /**
     * 
     * @param {number} customerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCustomerType(customerId: number, options?: RawAxiosRequestConfig): AxiosPromise<CustomerTypeResponseDto>;

    /**
     * 
     * @param {number} customerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getForeignBusinessCustomer(customerId: number, options?: RawAxiosRequestConfig): AxiosPromise<GetForeignBusinessCustomerResponseDto>;

    /**
     * 
     * @param {number} customerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getIndividualCustomer(customerId: number, options?: RawAxiosRequestConfig): AxiosPromise<GetIndividualCustomerResponseDto>;

    /**
     * PROSPECT to REJECTED with a mandatory reason; records the signed-in user and the time as the rejecter. Requires CUSTOMER_APPROVE. Leaves an entry with the reason on the customer timeline.
     * @summary Reject a Prospect with a reason
     * @param {number} customerId 
     * @param {RejectCustomerRequestDto} rejectCustomerRequestDto Reject a Prospect
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rejectCustomer(customerId: number, rejectCustomerRequestDto: RejectCustomerRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * REJECTED to PROSPECT, clearing the rejection reason, rejecter and time. Requires CONTACT_EDIT (or CONTACT_MANAGE_ALL). Leaves an entry on the customer timeline.
     * @summary Submit a rejected customer again as a Prospect
     * @param {number} customerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resubmitCustomer(customerId: number, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Get list of customers contacts
     * @param {number} page 
     * @param {number} pageSize 
     * @param {number} customerId 
     * @param {SearchCustomerContactsRequestDto} searchCustomerContactsRequestDto Customer contacts search request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchCustomerContacts(page: number, pageSize: number, customerId: number, searchCustomerContactsRequestDto: SearchCustomerContactsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ContactSearchResponseDto>;

    /**
     * 
     * @summary Get list of customers
     * @param {number} page 
     * @param {number} pageSize 
     * @param {SearchCustomersRequestDto} searchCustomersRequestDto Customer search request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchCustomers(page: number, pageSize: number, searchCustomersRequestDto: SearchCustomersRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CustomerSearchResponseDto>;

    /**
     * The edit does not change the approval state and never leaves or enters PROSPECT or REJECTED (400 CUSTOMER_STATUS_CHANGE_NOT_ALLOWED); ACTIVE and INACTIVE switch freely. A customer that does not exist is answered with 404 CUSTOMER_NOT_FOUND.
     * @param {number} customerId 
     * @param {BusinessCustomerDto} businessCustomerDto Update business customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateBusinessCustomer(customerId: number, businessCustomerDto: BusinessCustomerDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * The edit does not change the approval state and never leaves or enters PROSPECT or REJECTED (400 CUSTOMER_STATUS_CHANGE_NOT_ALLOWED); ACTIVE and INACTIVE switch freely. A customer that does not exist is answered with 404 CUSTOMER_NOT_FOUND.
     * @param {number} customerId 
     * @param {ForeignBusinessCustomerDto} foreignBusinessCustomerDto Update foreign business customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateForeignBusinessCustomer(customerId: number, foreignBusinessCustomerDto: ForeignBusinessCustomerDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * The edit does not change the approval state and never leaves or enters PROSPECT or REJECTED (400 CUSTOMER_STATUS_CHANGE_NOT_ALLOWED); ACTIVE and INACTIVE switch freely. A customer that does not exist is answered with 404 CUSTOMER_NOT_FOUND.
     * @param {number} customerId 
     * @param {IndividualCustomerDto} individualCustomerDto Update customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateIndividualCustomer(customerId: number, individualCustomerDto: IndividualCustomerDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * RestCustomersApi - object-oriented interface
 */
export class RestCustomersApi extends BaseAPI implements RestCustomersApiInterface {
    /**
     * 
     * @summary Add contact to customer
     * @param {number} customerId 
     * @param {number} contactId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addCustomerContact(customerId: number, contactId: number, options?: RawAxiosRequestConfig) {
        return RestCustomersApiFp(this.configuration).addCustomerContact(customerId, contactId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * PROSPECT or REJECTED to ACTIVE; records the signed-in user and the time as the approver and clears an earlier rejection. Requires CUSTOMER_APPROVE. Leaves an entry on the customer timeline.
     * @summary Approve a Prospect or a rejected customer (Zatwierdzenie klienta)
     * @param {number} customerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public approveCustomer(customerId: number, options?: RawAxiosRequestConfig) {
        return RestCustomersApiFp(this.configuration).approveCustomer(customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The customer is created as a Prospect (PROSPECT) unless `status` is ACTIVE, which needs CUSTOMER_APPROVE and records the signed-in user as the approver.
     * @param {CreateBusinessCustomerRequestDto} createBusinessCustomerRequestDto Create customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createBusinessCustomer(createBusinessCustomerRequestDto: CreateBusinessCustomerRequestDto, options?: RawAxiosRequestConfig) {
        return RestCustomersApiFp(this.configuration).createBusinessCustomer(createBusinessCustomerRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The customer is created as a Prospect (PROSPECT) unless `status` is ACTIVE, which needs CUSTOMER_APPROVE and records the signed-in user as the approver.
     * @param {CreateForeignBusinessCustomerRequestDto} createForeignBusinessCustomerRequestDto Create foreign customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createForeignBusinessCustomer(createForeignBusinessCustomerRequestDto: CreateForeignBusinessCustomerRequestDto, options?: RawAxiosRequestConfig) {
        return RestCustomersApiFp(this.configuration).createForeignBusinessCustomer(createForeignBusinessCustomerRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The customer is created as a Prospect (PROSPECT) unless `status` is ACTIVE, which needs CUSTOMER_APPROVE and records the signed-in user as the approver.
     * @param {CreateIndividualCustomerRequestDto} createIndividualCustomerRequestDto Create customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createIndividualCustomer(createIndividualCustomerRequestDto: CreateIndividualCustomerRequestDto, options?: RawAxiosRequestConfig) {
        return RestCustomersApiFp(this.configuration).createIndividualCustomer(createIndividualCustomerRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete contact from customer
     * @param {number} customerId 
     * @param {number} contactId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteCustomerContact(customerId: number, contactId: number, options?: RawAxiosRequestConfig) {
        return RestCustomersApiFp(this.configuration).deleteCustomerContact(customerId, contactId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} customerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getBusinessCustomer(customerId: number, options?: RawAxiosRequestConfig) {
        return RestCustomersApiFp(this.configuration).getBusinessCustomer(customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} customerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCustomerType(customerId: number, options?: RawAxiosRequestConfig) {
        return RestCustomersApiFp(this.configuration).getCustomerType(customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} customerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getForeignBusinessCustomer(customerId: number, options?: RawAxiosRequestConfig) {
        return RestCustomersApiFp(this.configuration).getForeignBusinessCustomer(customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} customerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getIndividualCustomer(customerId: number, options?: RawAxiosRequestConfig) {
        return RestCustomersApiFp(this.configuration).getIndividualCustomer(customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * PROSPECT to REJECTED with a mandatory reason; records the signed-in user and the time as the rejecter. Requires CUSTOMER_APPROVE. Leaves an entry with the reason on the customer timeline.
     * @summary Reject a Prospect with a reason
     * @param {number} customerId 
     * @param {RejectCustomerRequestDto} rejectCustomerRequestDto Reject a Prospect
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public rejectCustomer(customerId: number, rejectCustomerRequestDto: RejectCustomerRequestDto, options?: RawAxiosRequestConfig) {
        return RestCustomersApiFp(this.configuration).rejectCustomer(customerId, rejectCustomerRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * REJECTED to PROSPECT, clearing the rejection reason, rejecter and time. Requires CONTACT_EDIT (or CONTACT_MANAGE_ALL). Leaves an entry on the customer timeline.
     * @summary Submit a rejected customer again as a Prospect
     * @param {number} customerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public resubmitCustomer(customerId: number, options?: RawAxiosRequestConfig) {
        return RestCustomersApiFp(this.configuration).resubmitCustomer(customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get list of customers contacts
     * @param {number} page 
     * @param {number} pageSize 
     * @param {number} customerId 
     * @param {SearchCustomerContactsRequestDto} searchCustomerContactsRequestDto Customer contacts search request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchCustomerContacts(page: number, pageSize: number, customerId: number, searchCustomerContactsRequestDto: SearchCustomerContactsRequestDto, options?: RawAxiosRequestConfig) {
        return RestCustomersApiFp(this.configuration).searchCustomerContacts(page, pageSize, customerId, searchCustomerContactsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get list of customers
     * @param {number} page 
     * @param {number} pageSize 
     * @param {SearchCustomersRequestDto} searchCustomersRequestDto Customer search request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchCustomers(page: number, pageSize: number, searchCustomersRequestDto: SearchCustomersRequestDto, options?: RawAxiosRequestConfig) {
        return RestCustomersApiFp(this.configuration).searchCustomers(page, pageSize, searchCustomersRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The edit does not change the approval state and never leaves or enters PROSPECT or REJECTED (400 CUSTOMER_STATUS_CHANGE_NOT_ALLOWED); ACTIVE and INACTIVE switch freely. A customer that does not exist is answered with 404 CUSTOMER_NOT_FOUND.
     * @param {number} customerId 
     * @param {BusinessCustomerDto} businessCustomerDto Update business customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateBusinessCustomer(customerId: number, businessCustomerDto: BusinessCustomerDto, options?: RawAxiosRequestConfig) {
        return RestCustomersApiFp(this.configuration).updateBusinessCustomer(customerId, businessCustomerDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The edit does not change the approval state and never leaves or enters PROSPECT or REJECTED (400 CUSTOMER_STATUS_CHANGE_NOT_ALLOWED); ACTIVE and INACTIVE switch freely. A customer that does not exist is answered with 404 CUSTOMER_NOT_FOUND.
     * @param {number} customerId 
     * @param {ForeignBusinessCustomerDto} foreignBusinessCustomerDto Update foreign business customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateForeignBusinessCustomer(customerId: number, foreignBusinessCustomerDto: ForeignBusinessCustomerDto, options?: RawAxiosRequestConfig) {
        return RestCustomersApiFp(this.configuration).updateForeignBusinessCustomer(customerId, foreignBusinessCustomerDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The edit does not change the approval state and never leaves or enters PROSPECT or REJECTED (400 CUSTOMER_STATUS_CHANGE_NOT_ALLOWED); ACTIVE and INACTIVE switch freely. A customer that does not exist is answered with 404 CUSTOMER_NOT_FOUND.
     * @param {number} customerId 
     * @param {IndividualCustomerDto} individualCustomerDto Update customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateIndividualCustomer(customerId: number, individualCustomerDto: IndividualCustomerDto, options?: RawAxiosRequestConfig) {
        return RestCustomersApiFp(this.configuration).updateIndividualCustomer(customerId, individualCustomerDto, options).then((request) => request(this.axios, this.basePath));
    }
}

